import { SocialButton } from './SocialButton'
import { IconFacebook, IconX, IconLinkedin, IconLink } from '~/components/icons'
import { env } from '~/config/env'
import { routes } from '~/config/routes'
import { useCopyClipboard } from '~/hooks/use-copy-clipboard'
import { Tooltip } from '~/system/tooltip'

type Props = {
  slug: string
  fundraiserId?: string
}

export const PageSocialButtons = ({ slug, fundraiserId }: Props) => {
  const pageUrl =
    env.baseUrl + routes.fundraisingPage.home(slug, fundraiserId).as
  const taggedUrl = (source: string) =>
    encodeURIComponent(
      `${pageUrl}?utm_source=${source}&utm_medium=social&utm_campaign=fundraising_page`
    )
  const [copyClipboard, hasCopied] = useCopyClipboard(1000)

  return (
    <div className="flex items-center">
      <SocialButton
        href={`https://facebook.com/sharer/sharer.php?u=${taggedUrl('facebook')}`}
        target="_blank"
        rel="noopener"
        aria-label="Share on Facebook"
        icon={IconFacebook}
        hasLeftBorder
      />

      <SocialButton
        href={`https://x.com/intent/post?text=${taggedUrl('x')}`}
        target="_blank"
        rel="noopener"
        aria-label="Share on X"
        icon={IconX}
      />

      <SocialButton
        href={`https://www.linkedin.com/sharing/share-offsite?url=${taggedUrl('linkedin')}`}
        target="_blank"
        rel="noopener"
        aria-label="Share on LinkedIn"
        icon={IconLinkedin}
        hasRightBorder
      />

      <Tooltip open={hasCopied} size="sm">
        <SocialButton
          onClick={() => copyClipboard(`${pageUrl}?utm_source=share&utm_medium=clipboard&utm_campaign=fundraising`)}
          aria-label={hasCopied ? 'Link copied!' : 'Copy link'}
          icon={IconLink}
          hasLeftBorder
          hasRightBorder
          className="ml-2 cursor-pointer"
          as="button"
        />
        <span>Copied!</span>
      </Tooltip>
    </div>
  )
}
